var moment = require("moment-timezone"); moment.tz.add('GMT|GMT|0|0||');